import ServiceCategoryPage from "../components/ServiceCategoryPage";
import instaHelpService from "../data/services/instaHelpService";

function InstaHelp() {
  return <ServiceCategoryPage service={instaHelpService} />;
}

export default InstaHelp;